import { ApiParams, ApiParamsAlterate } from './../../models/api-params';
import { Injectable } from '@angular/core';
import {
  AtcDTO,
  NotificationDTO,
  PositionSaveRequestDTO,
  SurveyUpdateDTO,
  FormUpdateDTO,
  ReportRequestDTO,
  AuthenticateDTO,
  UserCustomerUpdateDTO,
  PostsellingCreateDTO,
  QuotationParamsDTO,
  PositionRequestDTO,
  LogRequestDTO,
  Api
} from '../../models';

@Injectable({
  providedIn: 'root'
})
export class InputAdapterService implements Api {
  putLog(params: ApiParams<void, LogRequestDTO>): ApiParamsAlterate<void> {
    return params;
  }

  getLabels(params: ApiParams<void, void>): ApiParams<void, void> {
    return params;
  }

  getDomain(
    params: ApiParams<{ code: string }, void>
  ): ApiParamsAlterate<{ code: string }> {
    return params;
  }

  postSecurityLogon(
    params: ApiParams<void, AuthenticateDTO>
  ): ApiParamsAlterate<void> {
    return params;
  }

  getSecurityVerify(params: ApiParams<void, void>): ApiParamsAlterate<void> {
    return params;
  }

  getSecurityUserData(params: ApiParams<void, void>): ApiParamsAlterate<void> {
    return params;
  }

  getOnboardingCustomer(
    params: ApiParams<{ userId: string }, void>
  ): ApiParamsAlterate<{ userId: string }> {
    return params;
  }

  putOnboardingCustomer(
    params: ApiParams<{ userId: string }, UserCustomerUpdateDTO>
  ): ApiParamsAlterate<{ userId: string }> {
    return params;
  }

  getQuotationsBoundaries(
    params: ApiParams<void, void>
  ): ApiParamsAlterate<void> {
    return params;
  }

  postQuotations(
    params: ApiParams<void, QuotationParamsDTO>
  ): ApiParamsAlterate<void> {
    return params;
  }

  postPositionSave(
    params: ApiParams<void, PositionSaveRequestDTO>
  ): ApiParamsAlterate<void> {
    return params;
  }

  postPosition(
    params: ApiParams<void, PositionRequestDTO>
  ): ApiParamsAlterate<void> {
    return params;
  }

  getPersonalPositions(params: ApiParams<void, void>): ApiParamsAlterate<void> {
    return params;
  }

  getPersonalTasks(params: ApiParams<void, void>): ApiParamsAlterate<void> {
    return params;
  }

  getPosition(
    params: ApiParams<{ positionId: string }, void>
  ): ApiParamsAlterate<{ positionId: string }> {
    return params;
  }

  getPositionCustomer(
    params: ApiParams<{ positionId: string }, void>
  ): ApiParamsAlterate<{ positionId: string }> {
    return params;
  }

  getPositionQuotation(
    params: ApiParams<{ positionId: string }, void>
  ): ApiParamsAlterate<{ positionId: string }> {
    return params;
  }

  getPositionFull(
    params: ApiParams<{ positionId: string }, void>
  ): ApiParamsAlterate<{ positionId: string }> {
    return params;
  }

  postPositionWithdraw(
    params: ApiParams<{ positionId: string }, { reasonCode: string }>
  ): ApiParamsAlterate<{ positionId: string }> {
    return params;
  }

  getPreWizard(
    params: ApiParams<{ wizardCode: string }, void>
  ): ApiParamsAlterate<{ wizardCode: string }> {
    return params;
  }

  getWizard(
    params: ApiParams<{ positionId: string; wizardCode: string }, void>
  ): ApiParamsAlterate<{ positionId: string; wizardCode: string }> {
    return params;
  }

  putWizardStepNext(
    params: ApiParams<
      { positionId: string; wizardCode: string; stepCode: string },
      Record<string, never>
    >
  ): ApiParamsAlterate<{
    positionId: string;
    wizardCode: string;
    stepCode: string;
  }> {
    return params;
  }

  putWorkflowTaskClose(
    params: ApiParams<
      { positionId: string; stepCode: string },
      Record<string, never>
    >
  ): ApiParamsAlterate<{ positionId: string; stepCode: string }> {
    return params;
  }

  getSurvey(
    params: ApiParams<{ positionId: string; surveyCode: string }, void>
  ): ApiParamsAlterate<{ positionId: string; surveyCode: string }> {
    return params;
  }

  putSurvey(
    params: ApiParams<
      { positionId: string; surveyCode: string },
      SurveyUpdateDTO
    >
  ): ApiParamsAlterate<{ positionId: string; surveyCode: string }> {
    return params;
  }

  getForm(
    params: ApiParams<{ positionId: string; formCode: string }, void>
  ): ApiParamsAlterate<{ positionId: string; formCode: string }> {
    return params;
  }

  postForm(
    params: ApiParams<{ positionId: string; formCode: string }, FormUpdateDTO>
  ): ApiParamsAlterate<{ positionId: string; formCode: string }> {
    return params;
  }

  getChecklist(
    params: ApiParams<{ positionId: string }, void>
  ): ApiParamsAlterate<{ positionId: string }> {
    return params;
  }

  getChecklistDocumentDownload(
    params: ApiParams<{ positionId: string; docId: string }, void>
  ): ApiParamsAlterate<{ positionId: string; docId: string }> {
    return params;
  }

  postChecklistDocumentUpload(
    params: ApiParams<{ positionId: string; docId: string }, FormData>
  ): ApiParams<{ positionId: string; docId: string }, FormData> {
    return params;
  }

  putChecklistDocumentOverride(
    params: ApiParams<
      { positionId: string; docId: string; fileId: string },
      FormData
    >
  ): ApiParams<
    { positionId: string; docId: string; fileId: string },
    FormData
  > {
    return params;
  }

  getChecklistDocumentScan(
    params: ApiParams<{ positionId: string; docId: string }, void>
  ): ApiParamsAlterate<{ positionId: string; docId: string }> {
    return params;
  }

  getChecklistDocumentCheckOcr(
    params: ApiParams<{ positionId: string; docId: string }, void>
  ): ApiParamsAlterate<{ positionId: string; docId: string }> {
    return params;
  }

  getReports(
    params: ApiParams<{ printType: string }, void>
  ): ApiParamsAlterate<{ printType: string }> {
    return params;
  }

  postReportModule(params: ApiParams<void, void>): ApiParamsAlterate<void> {
    return params;
  }

  postReport(
    params: ApiParams<
      { positionId: string; reportCode: string },
      ReportRequestDTO
    >
  ): ApiParamsAlterate<{ positionId: string; reportCode: string }> {
    return params;
  }

  postIdentificationStart(
    params: ApiParams<
      { method: string },
      {
        businessId: string;
        ndg: string;
      }
    >
  ): ApiParamsAlterate<{ method: string }> {
    return params;
  }

  getIdentificationVerify(
    params: ApiParams<{ method: string }, void>
  ): ApiParamsAlterate<{ method: string }> {
    return params;
  }

  getDigitalSignatureRequestDsp(
    params: ApiParams<{ positionId: string }, void>
  ): ApiParamsAlterate<{ positionId: string }> {
    return params;
  }

  getDigitalSignatureRequestStatusDsp(
    params: ApiParams<{ positionId: string }, void>
  ): ApiParamsAlterate<{ positionId: string }> {
    return params;
  }

  getDigitalSignatureSign(
    params: ApiParams<{ positionId: string }, void>
  ): ApiParamsAlterate<{ positionId: string }> {
    return params;
  }

  postPsd2Start(
    params: ApiParams<{ positionId: string }, void>
  ): ApiParamsAlterate<{ positionId: string }> {
    return params;
  }

  getPsd2Verify(
    params: ApiParams<{ positionId: string }, void>
  ): ApiParamsAlterate<{ positionId: string }> {
    return params;
  }

  getPositionQuotationBoundaries(
    params: ApiParams<{ positionId: string }, void>
  ): ApiParamsAlterate<{ positionId: string }> {
    return params;
  }

  putPositionQuotation(
    params: ApiParams<{ positionId: string }, QuotationParamsDTO>
  ): ApiParamsAlterate<{ positionId: string }> {
    return params;
  }

  putObligationConfirm(
    params: ApiParams<
      { positionId: string; obligationId: string },
      { isConfirmed: boolean }
    >
  ): ApiParamsAlterate<{ positionId: string; obligationId: string }> {
    return params;
  }

  getNotes(
    params: ApiParams<{ positionId: string; type: string }, void>
  ): ApiParamsAlterate<{ positionId: string; type: string }> {
    return params;
  }

  getAtc(params: ApiParams<void, void>): ApiParamsAlterate<void> {
    return params;
  }

  postAtc(
    params: ApiParams<{ atcId: number; positionId: string }, AtcDTO>
  ): ApiParamsAlterate<{ atcId: number; positionId: string }> {
    return params;
  }

  postContactSendOtp(
    params: ApiParams<
      { positionId: string; channelId: string },
      { contact: string }
    >
  ): ApiParamsAlterate<{ positionId: string; channelId: string }> {
    return params;
  }

  putContactVerifyOtp(
    params: ApiParams<
      { positionId: string; channelId: string },
      { contact: string; otp: string }
    >
  ): ApiParamsAlterate<{ positionId: string; channelId: string }> {
    return params;
  }

  getNotifications(
    params: ApiParams<{ positionId: string }, void>
  ): ApiParamsAlterate<{ positionId: string }> {
    return params;
  }

  putNotification(
    params: ApiParams<
      { notificationId: string; outcome: string },
      NotificationDTO
    >
  ): ApiParamsAlterate<{ notificationId: string; outcome: string }> {
    return params;
  }

  getQuotationCreditRequest(
    params: ApiParams<{ mode: string }, void>
  ): ApiParamsAlterate<{ mode: string }> {
    return params;
  }

  getQuotationCreditUse(
    params: ApiParams<{ mode: string }, void>
  ): ApiParamsAlterate<{ mode: string }> {
    return params;
  }

  postPostselling(
    params: ApiParams<
      { positionId: string; taskCode: string },
      PostsellingCreateDTO
    >
  ): ApiParamsAlterate<{ positionId: string; taskCode: string }> {
    return params;
  }

  postHandover(
    params: ApiParams<{ positionId: string; handoverCod: string }, void>
  ): ApiParamsAlterate<{ positionId: string; handoverCod: string }> {
    return params;
  }

  getHandover(
    params: ApiParams<{ positionId: string; handoverCod: string }, void>
  ): ApiParamsAlterate<{ positionId: string; handoverCod: string }> {
    return params;
  }

  getChannel(
    params: ApiParams<{ positionId: string }, void>
  ): ApiParamsAlterate<{ positionId: string }> {
    return params;
  }
}
